  
const ToggleSwitch = ({ name, id, onChange, value, checked, type }) => {

    return(
        <label className="switch strip">
            <input type="checkbox" id={id} name={name} 
                    value={value} onChange={onChange} checked={checked} />
            <span className={type === "candidate" ? "slider strip candidate" : "slider strip company"} />
        </label>
    )
};
  
export default ToggleSwitch;